module.exports = __webpack_public_path__ + "img/hyacintus-henry-djantoko.2e1f5290.jpg";